<template>
  <div>
    <EmptyMessage v-if="isErrorStatus(404)">
      <span slot="icon" class="icon">
        <i class="fas fa-exclamation-circle"></i>
      </span>
      <h3>ไม่พบหน้านี้</h3>
      <p>ลองตรวจสอบ URL หรือติดต่อผู้ดูแลระบบ</p>
      <router-link :to="redirectLink"
        class="btn btn-light btn-lg mt-4">
        กลับสู่หน้าหลัก
      </router-link>
      <span slot="code" class="code">
        Code : {{error.status || 'not found' }}
      </span>
    </EmptyMessage>
    <EmptyMessage v-if="isErrorStatus(403)">
      <h3>ขออภัย คุณไม่มีสิทธิ์เข้าถึงหน้านี้</h3>
      <router-link :to="redirectLink"
        class="btn btn-light btn-lg mt-4">
        กลับสู่หน้าหลัก
      </router-link>
      <span
        slot="code"
        class="code">
        Code : {{error.status || 'not found' }}
      </span>
    </EmptyMessage>
    <EmptyMessage v-if="isErrorStatus(500)">
      <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
      <p>
        โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อผู้ดูแลระบบ
      </p>
      <span
        slot="code"
        class="code">
        Code : {{error.status || 'not found' }}
      </span>
    </EmptyMessage>
  </div>
</template>

<script>
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    redirectLink: {
      type: String,
      default: '/',
    },
  },
  components: {
    EmptyMessage,
  },
  methods: {
    isErrorStatus(statusCode) {
      switch (statusCode) {
        case 404:
          return this.error.status === 404;
        case 401:
          return this.error.status === 401;
        case 403:
          return this.error.status === 403;
        case 500:
          return this.error.status === 500;
        default:
          return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

</style>
